import { getLanguagesDefaultDatas, LANGUAGE_TYPE_OPTIONS } from '@/packages/plugins/hook/useLanguage'
import TextInput from './components/textInput.vue'
import TextareaInput from './components/textAreaInput.vue'
import RadioGroup from './components/radioGroup.vue'
import CheckboxGroup from './components/checkboxGroup.vue'
import ImageRadioGroup from './components/imageRadioGroup.vue'
import ImageCheckboxGroup from './components/imageCheckboxGroup.vue'
import TextNumberInput from './components/textNumberInput.vue'
import TextAreaNumberInput from './components/textAreaNumberInput.vue'

/** 问卷-选项样式配置项 */
export const SURVEY_QUESTION_ITEM = {
  optionMarginTop: null,
  optionMarginBottom: null,
  optionPaddingTop: null,
  optionPaddingBottom: null,
  optionPaddingLeft: null,
  optionPaddingRight: null,
  optionFontSize: null,
  optionRadius: null,
  optionImgWidth: null,
  optionImgHeight: null,
  optionImgRadius: null,
  optionWidth: null,
  optionBorderSize: null,
  optionBorderColor: null,
  optionBackgroundColor: null,
  optionOtherBorderColor: null,
  optionOtherBorderSize: null,
  optionOtherBorderRadius: null,
  optionOtherBackgroundColor: null,
  optionOtherWidth: null,
  optionOnlyBorderBottom: null,
  textAreaRows: null,
  selectBg: null,
  selectedBg: null,
  selectMark: null,
  selectBorderColor: null
}

/** 问卷-选项通用样式配置项 */
export const SURVEY_QUESTION_TYPE_ITEM = {
  optionMarginTop: 10,
  optionMarginBottom: 10,
  optionPaddingTop: 20,
  optionPaddingBottom: 20,
  optionPaddingLeft: 20,
  optionPaddingRight: 20,
  optionFontSize: 16,
  optionRadius: 16,
  optionImgWidth: 40,
  optionImgHeight: 40,
  optionImgRadius: 16,
  optionWidth: 400,
  optionBorderSize: 2,
  optionBorderColor: '#000',
  optionBackgroundColor: '#fff',
  optionOtherBorderColor: '#000',
  optionOtherBorderSize: 2,
  optionOtherBorderRadius: 16,
  optionOtherBackgroundColor: '#fff',
  optionOtherWidth: 600,
  optionOnlyBorderBottom: false,
  textAreaRows: 3,
  selectBg: '#fff',
  selectedBg: '#007aff',
  selectMark: '#fff',
  selectBorderColor: '#000'
}

/** 问卷-选项配置项 */
export const GET_SURVEY_OPTION_ITEM = (props) => {
  return {
    languages: getLanguagesDefaultDatas(LANGUAGE_TYPE_OPTIONS, props)
  }
}

/** 问卷-问题类型对应初始化表单数据 */
export const TYPE_TO_INIT_DATA = {
  1: '',
  2: '',
  3: '',
  4: [],
  5: '',
  6: []
}

/** 问卷-问题类型对应名称 */
export const TYPE_TO_NAME = {
  1: '单行文本',
  2: '多行文本',
  3: '图片单选',
  4: '图片多选',
  5: '单选',
  6: '多选'
}

/** 问卷-支持的表单项组件 */
export const COMPONENT_MAP = {
  1: TextInput,
  2: TextareaInput,
  3: ImageRadioGroup,
  4: ImageCheckboxGroup,
  5: RadioGroup,
  6: CheckboxGroup
}

/** 问卷-支持的表单项组件-数字型 */
export const COMPONENT_NUMBER_MAP = {
  1: TextNumberInput,
  2: TextAreaNumberInput
}
